/**
 * 10.9HJ — PEDRA COM RELEVO NAS PAREDES (muralha da região, paredes da Fenda dos Titãs).
 * As paredes são caixas instanciadas com tamanhos diferentes: UV 0..1 por face esticaria a
 * textura. Aqui a textura é mapeada pelo ESPAÇO DO MUNDO (x+z na horizontal, y na vertical),
 * então o padrão tem o mesmo tamanho em qualquer bloco e continua de um bloco pro vizinho.
 * Usa o mesmo conjunto "rock" (albedo + normal) do chão — nada novo pra carregar.
 */
import * as THREE from "three";
import { groundTextures } from "./GroundTextures";
import { quality } from "../core/Quality";

export function applyWorldStone(mat: THREE.MeshStandardMaterial, scale = 0.14): void {
  const rock = groundTextures("rock");
  mat.map = rock.map;
  if (quality.values.normalMaps) {
    mat.normalMap = rock.normalMap;
    mat.normalScale.set(0.6, 0.6);
  }
  mat.onBeforeCompile = (shader) => {
    shader.vertexShader = shader.vertexShader.replace(
      "#include <begin_vertex>",
      `#include <begin_vertex>
      vec4 vhWP = vec4( transformed, 1.0 );
      #ifdef USE_INSTANCING
        vhWP = instanceMatrix * vhWP;
      #endif
      vhWP = modelMatrix * vhWP;
      vMapUv = vec2( vhWP.x + vhWP.z, vhWP.y ) * ${scale.toFixed(3)};
      #ifdef USE_NORMALMAP
        vNormalMapUv = vMapUv;
      #endif`,
    );
  };
  mat.customProgramCacheKey = () => `vhWorldStone${quality.values.normalMaps ? "N" : ""}`;
  mat.needsUpdate = true;
}
